import * as Colors from 'material-ui/styles/colors';
import * as Consts from '../common/Consts';

export default {
  title: {
    backgroundColor: Colors.grey800,
    height: Consts.TITLE_HEIGHT,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: Colors.white,
    fontSize: 24,
    paddingLeft: 20,
  },
  buttonsSection: {
    height: Consts.BUTTONS_SECTION_HEIGHT,
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    position: 'absolute',
    left: 0,
    bottom: 0,
  },
  mainButton: {
    marginRight: 12.5,
    minWidth: 140
  },
  content: {
    height: Consts.CONTENT_HEIGHT,
    maxHeight: Consts.CONTENT_MAX_HEIGHT,
    overflowY: 'auto',
    overflowX: 'hidden',
    position: 'relative',
  },
};
